import { File } from './file'
import { Translator } from './translator'

export class Teacher extends Translator{
    id:string
    nameEn:string =  "" 
    nameKh:string = ""
    avatarUrl:string = ""
    position:string = ""
    about:string = ""
    email:string = ""
    image:File
    get name():string{
        return this.translate(this.nameEn,this.nameKh)
    }
}